import { Box, Container, Divider, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Hero from "../components/UI/Hero";

const TermsOfUse = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("seo.title.terms_of_use")}</title>
        <meta name="description" content={t("seo.description.terms_of_use")} />
        <meta property="og:title" content={t("seo.title.terms_of_use")} />
        <meta
          property="og:description"
          content={t("seo.description.terms_of_use")}
        />
      </Helmet>
      <Hero
        title={t("hero.terms_of_use.title")}
        subtitle={t("hero.terms_of_use.subtitle")}
      />
      <Container maxWidth="md" sx={{ my: 10 }}>
        <Box sx={{ mt: 5 }}>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 5, display: "block" }}
          >
            Spēkā stāšanās datums: 2025. gada 16. augusts <br />
            <br />
            Laipni lūdzam Cenaudze platformā! Izmantojot mūsu pakalpojumus, jūs
            piekrītat šiem Lietošanas noteikumiem. Lūdzu, izlasiet tos uzmanīgi.
          </Typography>

          <Typography
            color="primary"
            variant="h3"
            sx={{ mb: 2, display: "block" }}
          >
            1. Konti
          </Typography>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 5, display: "block" }}
          >
            - YLai izmantotu platformu, jums jāreģistrējas.
            <br />
            - Jūs drīkstat izveidot vairākus kontus, ja tas ir pamatoti ar jūsu
            uzņēmējdarbību, taču tos nedrīkst izmantot spamošanai vai izsoles
            manipulācijām.
            <br />- Sargiet savus piekļuves datus. Jūs esat atbildīgs par visu
            darbību, kas notiek jūsu kontos.
          </Typography>

          <Typography
            color="primary"
            variant="h3"
            sx={{ mb: 2, display: "block" }}
          >
            2. Izsoles un solīšana
          </Typography>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 5, display: "block" }}
          >
            - Visas izsoles ir ar noteiktu laiku.
            <br />
            - Izsoles īpašnieks drīkst jebkurā brīdī atcelt savu izsoli.
            <br />
            - Kad solījums ir veikts, tas tiek uzskatīts par galīgu.
            <br />- Ja uzvarētājs atsakās samaksāt, jautājums tiek risināts
            starp solītāju un izsoles īpašnieku. Cenaudze nav atbildīga par
            strīdiem starp lietotājiem.
          </Typography>

          <Typography
            color="primary"
            variant="h3"
            sx={{ mb: 2, display: "block" }}
          >
            3. Maksājumi un maksas
          </Typography>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 5, display: "block" }}
          >
            - Cenaudze neveic maksājumu apstrādi tieši.
            <br />
            - Izsoles īpašnieki maksā nelielu izvietošanas maksu, lai publicētu
            izsoli — šī maksa automātiski tiek pieskaitīta izsoles cenai.
            <br />- Izņemot izvietošanas maksu, platformas izmantošanai netiek
            piemērotas papildu maksas.
          </Typography>

          <Typography
            color="primary"
            variant="h3"
            sx={{ mb: 2, display: "block" }}
          >
            4. Lietotāju saturs
          </Typography>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 5, display: "block" }}
          >
            - Jūs drīkstat ievietot attēlus un aprakstus par mežiem, īpašumiem
            vai koksni.
            <br />
            - Nedrīkst publicēt pašportretus, neatbilstošus fotoattēlus,
            nelikumīgu saturu vai materiālus pieaugušajiem.
            <br />- Jūs pilnībā atbildat par saturu, ko ievietojat platformā.
          </Typography>

          <Typography
            color="primary"
            variant="h3"
            sx={{ mb: 2, display: "block" }}
          >
            5. Atbildības ierobežojums
          </Typography>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 5, display: "block" }}
          >
            Mēs darām visu iespējamo, lai nodrošinātu drošu platformas darbību,
            taču neesam atbildīgi par:
            <br />
            - pazaudētām vai bojātām precēm,
            <br />
            - maksājumu strīdiem,
            <br />
            - izsoles atcelšanu no īpašnieka puses,
            <br />
            - jebkādiem citiem starpgadījumiem starp lietotājiem.
            <br />
          </Typography>

          <Typography
            color="primary"
            variant="h3"
            sx={{ mb: 2, display: "block" }}
          >
            6. Konta apturēšana un dzēšana
          </Typography>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 5, display: "block" }}
          >
            Mēs varam apturēt vai slēgt jūsu kontu, ja tiek pārkāpti šie
            Lietošanas noteikumi.
            <br />
            Jūs jebkurā laikā varat slēgt savu kontu, sazinoties ar mums vai
            izmantojot konta iestatījumus.
          </Typography>

          <Typography
            color="primary"
            variant="h3"
            sx={{ mb: 2, display: "block" }}
          >
            7. Piemērojamie tiesību akti
          </Typography>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 5, display: "block" }}
          >
            Šos Lietošanas noteikumus regulē Latvijas Republikas likumi. Visi
            strīdi tiks risināti saskaņā ar Latvijas tiesību aktiem.
          </Typography>

          <Typography
            color="primary"
            variant="h3"
            sx={{ mb: 2, display: "block" }}
          >
            8. Noteikumu izmaiņas
          </Typography>
          <Typography
            color="primary"
            variant="body"
            sx={{ mb: 5, display: "block" }}
          >
            Laiku pa laikam mēs varam atjaunināt šos noteikumus. Turpinot
            izmantot platformu pēc izmaiņām, jūs piekrītat jaunajai Lietošanas
            noteikumu versijai.
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default TermsOfUse;
